import * as yup from "yup";

export const loginSchema = yup.object().shape({
  username: yup.string().required("Username is required"),
  password: yup.string().required("Password is required"),
});


export const guardSchema = yup.object().shape({
  name: yup
    .string()
    .required("Name is required")
    .matches(/^[A-Za-z\s]+$/, "Name can only contain letters and spaces"),

  username: yup
    .string()
    .required("Username is required")
    .matches(
      /^[a-zA-Z0-9_]{3,30}$/,
      "Username must be 3-30 characters and can include letters, numbers, underscores"
    ),

  contactNumber: yup
    .string()
    .required("Contact Number is required")
    .matches(
      /^\+\d{11,15}$/,
      "Contact Number must start with '+' and be 11 to 15 digits"
    ),

  shiftStartTime: yup.string().required("Shift Start Time is required"),
  shiftEndTime: yup.string().required("Shift End Time is required"),

  password: yup
    .string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters long"),
});


export const buildingSchema = yup.object().shape({
  name: yup
    .string()
    .required("Building Name is required")
    .min(3,"Building Name must be more 2 than characters")
    .max(20, "Building Name must be at most 20 characters")
    .matches(/^[A-Za-z\s]+$/, "City can only contain letters and spaces"),

  location: yup.object().shape({
    address: yup.string().required("Address is required"),

    city: yup
      .string()
      .required("City is required")
      .matches(/^[A-Za-z\s]+$/, "City can only contain letters and spaces"),

    state: yup
      .string()
      .required("State is required")
      .matches(/^[A-Za-z\s]+$/, "State can only contain letters and spaces"),

    country: yup
      .string()
      .required("Country is required")
      .matches(/^[A-Za-z\s]+$/, "Country can only contain letters and spaces"),
  }),
});

export type BuildingForm = yup.InferType<typeof buildingSchema>;



export const userSchema = yup.object().shape({
  name: yup.string().required("Name is required").matches(/^[A-Za-z\s]+$/, "Name can only contain letters and spaces"),
  contactInfo: yup.object().shape({
    phone: yup
      .string()
      .required("Phone number is required")
      .matches(
        /^\+\d{11,15}$/,
        "Phone must start with + and be 11-15 digits"
      ),
    email: yup
      .string()
      .required("Email is required")
      .email("Must be a valid email")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Invalid email address'
      ),
  }),

  username: yup
    .string()
    .required("Username is required")
    .matches(
      /^[a-zA-Z0-9_]{3,30}$/,
      "Username must be 3-30 characters long and can only include letters, numbers, and underscores"
    ),

  licenses: yup
    .number()
    .typeError("Licenses must be a number")
    .required("Licenses is required")
    .min(1, "Licenses must be greater than 0")
    .max(2000, "Licenses must not exceed 2000"),
});
export const superAdminSchema = yup.object().shape({
  name: yup.string().required("Name is required").matches(/^[A-Za-z\s]+$/, "Name can only contain letters and spaces"),
  username: yup
    .string()
    .required("Username is required")
    .matches(
      /^[a-zA-Z0-9_]{3,10}$/,
      "Username must be 3-10 characters long and can only include letters, numbers, and underscores"
    ),
  password: yup.string().required("Password is required").min(6, "Password must be at least 6 characters long"),
  contactInfo: yup.object().shape({
    phone: yup
      .string()
      .required("Phone number is required")
      .matches(
        /^\+\d{1,3}\d{9,12}$/,
        "Phone number must include country code and be up to 15 digits in total"
      ),
    email: yup
      .string()
      .required("Email is required")
      .email("Must be a valid email")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Invalid email address'
      ),
  }),
});

export const updateAdminSchema = yup.object().shape({
  name: yup
    .string()
    .optional()
    .matches(/^[A-Za-z\s]+$/, "Name can only contain letters and spaces"),

  phone: yup
    .string()
    .optional()
    .matches(/^\+\d{11,15}$/, "Phone number must start with '+' and be 11 to 15 digits"),

  email: yup
    .string()
    .optional()
    .email("Must be a valid email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Invalid email address'
    ),

  username: yup
    .string()
    .optional()
    .matches(
      /^[a-zA-Z0-9_]{3,10}$/,
      "Username must be 3-10 characters and can include letters, numbers, underscores"
    ),

  currentPassword: yup
    .string()
    .optional(),

  newPassword: yup
    .string()
    .optional()
    .min(6, "New password must be at least 6 characters long"),
});
export const tenantSchema = yup.object().shape({
  name: yup.string().required("Tenant Name is required"),
  contactNumber: yup.string().required("Contact Number is required"),
  email: yup
    .string()
    .email("Invalid email address")
    .required("Email Address is required")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Invalid email address'
    ),
  username: yup.string().required("Username is required"),
  flatNo: yup.string().required("Flat Number is required"),
  leaseStartDate: yup.date().required("Lease Start Date is required"),
  leaseEndDate: yup
    .date()
    .min(
      yup.ref("leaseStartDate"),
      "Lease End Date can't be earlier than Lease Start Date"
    )
    .required("Lease End Date is required"),
});
export type UpdateAdminForm = yup.InferType<typeof updateAdminSchema>;
